import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const StyledAddSignalButtonWrapper = styled(FlexRow)``;
